
class CustomBundle {
  constructor(container) {
    this.container = container;
    this.mainBundleProduct = container.querySelector('[data-main-product]');
    this.bundleButton = Array.from(container.querySelectorAll('[data-add-bundle]'));
    this.allProducts = Array.from(container.querySelectorAll('[data-groups-pr-ck]'));
    this.productOptions = $(container).find("[data-bundle-product]");
    this.viewButtons = $(container).find("[data-view-button]");
    this.detailsEl = $(container).find("[data-product-details]");
    
    this.init();
  }

  init() {
    this.bundleButton.forEach(button => {
      button.addEventListener('click', (e) => this.onAddToCartClick(e));
    });

    this.productOptions.on("change", this.onProductOptionChange.bind(this));
    this.disableATCButton();

    // set initial height for details elements
    this.detailsEl.each((index, el) => {
      const itemHeight = $(el).find('.c-product-fbt__product-details__inner')[0].clientHeight;
      $(el).attr("data-height", itemHeight + 24);
      $(el).css("max-height", '0');
    })

    this.viewButtons.on("click", (e) => this.onViewButtonClick(e));
  }

  async addToCart(formData) {
    const formDataItems = {
      'items': formData
     };
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formDataItems)
    })
    .then(response => response.json())
    .then(cartItem => {
      T4SThemeSP.Cart.getToFetch();
      document.querySelector('[data-cart-open]')?.click();
    })
    .catch(error => console.error('Error:', error));
  }

  get selectionsCount() {
    return $(this.container).find("input[data-groups-pr-ck][data-bundle-product]:checked").length
  }

  get maxSelections() {
    let maxSelections = $(this.container).attr("data-max-selection");
    maxSelections = parseInt(maxSelections);
    return maxSelections ? maxSelections : 3;
  }

  disableNonSelections() {
    const notSelected = $(this.container).find("input[data-groups-pr-ck][data-bundle-product]:not(:checked)");
    const parentItems = notSelected.closest("[data-bundle-product-item]");
    notSelected.prop("disabled", true);
    parentItems.addClass("is-disabled");
  }

  disableATCButton() {
    $(this.bundleButton).prop("disabled", this.selectionsCount <= 0);
  }

  enableOptions() {
    const productItems = $(this.container).find("[data-bundle-product-item]");
    const checkboxes = productItems.find("input[data-groups-pr-ck][data-bundle-product]");
    productItems.removeClass("is-disabled");
    checkboxes.prop("disabled", false);
  }

  // Events

  onProductOptionChange(e) {
    const maxSel = this.maxSelections;
    const curSel = this.selectionsCount;
    this.disableATCButton();

    if (curSel >= maxSel) {
      this.disableNonSelections();
    } else {
      this.enableOptions();
    }
  }

  onAddToCartClick(e) {
    e.preventDefault();
    const mainProductId = $(this.mainBundleProduct).val();
    let items = [];
    let childIds = "";

    for (const item of this.allProducts) {
      const itemParent = $(item).parent();
      const selectedProduct = itemParent.find('[data-groups-pr-ck][type="checkbox"]:checked');
      const selectedVariantId = itemParent.find('[data-bundle-id]').val();
      const selectedProductId = itemParent.find('[data-bundle-product]').attr("data-product-id");

      if (selectedVariantId == mainProductId) continue;

      if (selectedProduct.length === 0 || !selectedVariantId) {
        console.error('No selected product found.');
        continue;
      }

      childIds = `${childIds == "" ? "" : (childIds + ",")}${selectedProductId}-${selectedVariantId}`;
    }

    items.push({
      quantity: 1,
      id: mainProductId,
      properties: {
        '_Child ID': `${childIds}${", parent-" + mainProductId}`,
        '_unique_bundle_id': `${mainProductId}-${Date.now()}`
      }
    });

    this.addToCart(items);
  }

  onViewButtonClick(e) {
    const targetEl = e.currentTarget;
    const parent = $(targetEl).closest("[data-groups-pr-item]");
    const detailsEl = parent.find("[data-product-details]");
    const height = $(detailsEl).attr("data-height");

    if (targetEl.classList.contains("is-open")) {
      $(targetEl).removeClass("is-open");
      $(detailsEl).css("max-height", '0');
    } else {
      $(targetEl).addClass("is-open");
      $(detailsEl).css("max-height", `${height}px`);
    }
  }
}

document.querySelectorAll("[data-product-fbt]")?.forEach(container => {
  new CustomBundle(container);
});
